 <template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        size="mini"
        :style="{ width: width, margin: margin }"
        placeholder="请选择线客户级别"
        clearable
        filterable >
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array, Number],
            default: null
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    mounted () {
        this.$http.post('/9api/crm/customer-level/select-all').then(rps => {
            this.select = rps.data
        })
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
            this.$emit('onChange', data)
        }
    }
}
</script>